import comp from "./AutomaticIBScaleToolV2";
export default comp;
